import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function CheckoutFailed() {
  return (
    <div data-testid="checkout-failed" className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-5">
        <XCircle className="w-8 h-8 text-destructive" />
      </div>
      <h1 className="font-serif text-4xl font-light text-foreground mb-3">Betaling mislukt</h1>
      <p className="text-muted-foreground mb-8 max-w-sm leading-relaxed">
        Uw betaling werd niet voltooid. Uw winkelmand is bewaard — u kunt het opnieuw proberen.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Link to="/checkout" className="px-8 py-3 bg-primary text-primary-foreground rounded-full font-semibold hover:bg-primary/90 transition-all active:scale-95">
          Opnieuw proberen
        </Link>
        <Link to="/cart" className="px-8 py-3 border border-border rounded-full font-medium hover:bg-muted transition-colors">
          Winkelmand bekijken
        </Link>
      </div>
    </div>
  );
}
